import { Button, DatePicker, Modal } from "antd";
import { useState } from "react";
import locale from "antd/es/date-picker/locale/pt_BR";
import { api } from "../../config";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../interfaces/users";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { Dayjs } from "dayjs";
import { SearchAssemblers } from "../Shared/Components/SearchAssemblers/SearchAssemblers";

interface ManagementReportModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ManagementReportModal = ({ isOpen, onClose }: ManagementReportModalProps) => {
  const { token } = useSelector((state: AuthenticationState) => state);
  const [assembler, setAssembler] = useState<number | undefined>();
  const [loading, setLoading] = useState(false)

  const { RangePicker } = DatePicker;
  const [start, setStart] = useState<Dayjs | null>();
  const [end, setEnd] = useState<Dayjs | null>();

  const handleClose = () => {
    setStart(null);
    setEnd(null);
    onClose();
  };

  const handleGenerate = async () => {
    if (!start || !end) return toast.error("Selecione o período corretamente");
    try {
      setLoading(true)
      const data = await api(token).get(
        `tickets/financial-report?start=${format(
          start?.toDate() ?? 0,
          "yyyy-MM-dd"
        )}&end=${format(end?.toDate() ?? 0, "yyyy-MM-dd")}${
          assembler ? `&ownerId=${assembler}` : ""
        }`
      );
      downloadCsv(data);
      handleClose();
      setAssembler(undefined)
      setStart(undefined)
      setEnd(undefined)
      return;
    } catch (error) {
      toast.error("Ocorreu um erro ao gerar o relatório");
    } finally {
      setLoading(false)
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      onCancel={handleClose}
      footer={() => (
        <Button
          loading={loading}
          onClick={handleGenerate}
          variant="solid"
          color="primary"
        >
          Gerar
        </Button>
      )}
    >
      <p>Período:</p>
      <RangePicker
        className="w-full"
        locale={locale}
        value={[start, end]}
        format="DD-MM-YYYY"
        onChange={(e) => {
          if (e?.length) {
            setStart(e?.[0]);
            setEnd(e?.[1]);
          }
        }}
      />

      <p>Montador:</p>
      <SearchAssemblers
        setAssembler={setAssembler}
        assembler={assembler}
        disabled={false}
        onSearch={() => console.log("test")}
      />
    </Modal>
  );
};


export function downloadCsv(csvText: string, filename = "dados.csv") {
  const bom = "\uFEFF";
  const blob = new Blob([bom + csvText], { type: "text/csv;charset=utf-8;" });

  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
